
<template>
	<div class="d-flex h-100" style="gap: 1rem;">

		<div style="flex: 1;overflow-y: auto;overflow-x: hidden;">

			<!-- Сравнительный подход -->
			
			<div v-if="group.cost_evaluation_comparative && active_step.startsWith('comparative')" :set="data = group.cost_evaluation_comparative"
				class="d-flex h-100" style="flex-direction: column;"
			>
				
				<b-row v-if="!group.not_editable && !data.modeling.fixed">
	
					<b-col>
	
						<b-nav pills>
	
							<b-dropdown v-if="data.type == 'Метод статистического (регрессионного) моделирования' && check_roles([ 'model' ])" variant="outline-primary" id="modeling_settings" menu-class="dropdown-menu">
	
								<template #button-content><base-icon name="settings" /></template>
	
								<b-tooltip target="modeling_settings" triggers="hover" container="fullscreen">Статистическая модель</b-tooltip>
	
								<b-dropdown-item variant="primary" v-on:click="$refs.modeling.setup()">Настроить</b-dropdown-item>
								<!--
								<b-dropdown-item variant="primary" v-on:click="$refs.modeling.evaluate_confidence()">Пересчитать доверительный интервал</b-dropdown-item>
								<b-dropdown-item variant="primary" v-on:click="$refs.modeling.set_confidence()">Задать доверительный интервал</b-dropdown-item>
								-->
	
							</b-dropdown>
	
						</b-nav>
	
					</b-col>
	
					<b-col class="d-flex justify-content-end align-items-center">
	
						<!-- <span>Метод: {{ data.type }}</span> -->
	
						<div v-if="data.type == 'Метод статистического (регрессионного) моделирования' && data.modeling && check_roles([ 'model' ])" class="ml-2" v-on:click="evaluate_model">
	
							<base-icon name="refresh" :animation_spin="progress"/>
	
						</div>
	
					</b-col>
	
				</b-row>
	
				<modeling ref="modeling" v-if="data.type == 'Метод статистического (регрессионного) моделирования'" :active_step="active_step" :id="data.id" :data="data.modeling" :cost_evaluation_data="data" :group_id="group_id" v-on:need_refresh="() => $emit('need_refresh')" v-on:evaluate_model="() => evaluate_model()" :not_editable="group.not_editable" v-on:set_steps_value="set_steps_value"/>
				
			</div>

			<reference v-if="active_step && active_step.startsWith('reference')"
				:active_step="active_step"
				:group_id="group_id"
				:id="group.cost_evaluation_comparative.id" :cost_evaluation_data="group.cost_evaluation_comparative"
				v-on:need_refresh="() => $emit('need_refresh')"
				:not_editable="group.not_editable"
				v-on:set_active_step="set_active_step_by_id"
			/>
	
			<!-- Затратный подход -->
	
			<div v-if="group.cost_evaluation_expensive && active_step.startsWith('expensive')" class="h-100" :set="data = group.cost_evaluation_expensive">
	
				<comparative_element v-if="data.type == 'Метод сравнительной единицы'" :active_step="active_step" :id="data.id" :group_id="group_id" :data="data.comparative_element" :cost_evaluation_data="data" v-on:need_refresh="() => $emit('need_refresh')" :not_editable="group.not_editable" />
				
			</div>
	
			<!-- Доходный подход -->
	
			<div v-if="group.cost_evaluation_profitable && active_step.startsWith('profitable')" class="h-100" :set="data = group.cost_evaluation_profitable">
	
				<!--
				<capitalization v-if="data.type == 'Метод прямой капитализации'" :active_step="active_step" :id="data.id" :group_id="group_id" :data="data.capitalization" :cost_evaluation_data="data" v-on:need_refresh="() => $emit('need_refresh')" /> 
				-->

				<capitalization ref="capitalization"
					:id="data.id" v-if="data.type == 'Метод прямой капитализации'" :group_id="group_id" :data="data.capitalization" :not_editable="group.not_editable" :cost_evaluation_data="data" v-on:need_refresh="() => $emit('need_refresh')"
					:active_step="active_step" v-on:set_active_step="set_active_step_by_id" v-on:set_steps_value="set_steps_value"
				/>
				
			</div>

			<individual v-if="active_step && active_step.startsWith('individual')" :id="group_id" :active_step="active_step" :data="group.cost_evaluation_individual ? group.cost_evaluation_individual.individual : {}" v-on:need_refresh="() => $emit('need_refresh')" v-on:set_active_step="set_active_step_by_id"/>
	
			<mydetails v-if="active_step == 'results'" :id="group_id" :data="group"/>

		</div>

		<steps ref="steps" :steps_items="steps_items" v-on:set_active_step="set_active_step" />
	</div>
</template>

<script>

import api from "../../../../api"
import modeling from "./modeling"
import reference from "./reference"
import comparative_element from "./comparative_element"
import capitalization from "./capitalization"
import individual from "./individual/"
import o from './modeling/objects'
import mydetails from './details'
import steps from "../../../widgets/steps"
import setups from "./setups"
import get_active_step from "./get_active_step"

export default
{
	props :
	{
		group_id : String,
		group : Object,
	},

	components :
	{
		modeling,
		reference,
		comparative_element,
		capitalization,
		individual,
		mydetails,
		steps
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			progress : false,

			active_step : null,
			
			steps_items : [],

		}
	},

	watch :
	{
		group(group)
		{
			if (group)
			{
				this.update_steps()
			}
		},
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		update_steps()
		{
			const steps = setups.getSteps(this.group, !this.check_roles([ "model", "cost" ]))
			this.steps_items = steps

			if (this.active_step == null)
			{
				const active_step = get_active_step(this, steps)

				this.set_active_step_by_id(active_step)
			}
		},

		set_steps_value(new_values)
		{
			var steps = api.deep_clone(this.steps_items)

			new_values.forEach(new_value => {
				function set_steps_value_by_id(steps)
				{
					var step_index = steps.findIndex(e => new_value.id.startsWith(e.id))
	
					if (steps[step_index].id == new_value.id) steps[step_index] = {...steps[step_index], ...new_value}
					else if (steps[step_index].children)
					{
						set_steps_value_by_id(steps[step_index].children)
					}
				}
	
				set_steps_value_by_id(steps)
			})
			
			this.steps_items = steps
			this.$refs.steps.set_active_step({id : this.active_step})
		},

		set_active_step_by_id(step_id)
		{
			var steps = api.deep_clone(this.steps_items)
			
			function set_steps_value_by_id(steps)
			{
				var step_index = steps.findIndex(e => step_id.startsWith(e.id))

				if (step_index != -1)
				{	
					if (steps[step_index].not_visible_children)
						steps[step_index] = {...steps[step_index], not_visible_children : false, }
					if(!step_id.match(new RegExp(`${steps[step_index].id}_\\d$`) && steps[step_index].children))
						set_steps_value_by_id(steps[step_index].children)
				}
			}

			set_steps_value_by_id(steps)
			
			this.steps_items = steps
			if (this.$refs.steps) this.$refs.steps.set_active_step({id : step_id})
		},

		set_active_step(step_id)
		{
			function close_steps(steps)
			{
				steps.forEach((e, i) => {
					if ((!step_id.startsWith(e.id) || step_id == e.id) && !e.not_visible_children)
						steps[i].not_visible_children = true

					if (e.children && (e.id.startsWith('profitable') || e.id.startsWith('reference')))
						close_steps(steps[i].children)
				})
			}

			if (step_id.startsWith('reference'))
			{
				const steps = api.deep_clone(this.steps_items)

				close_steps(steps)

				this.steps_items = steps

				api.storage.set(this, `cost_evaluation_${this.group_id}`, JSON.stringify({
					active_step : step_id
				}))
			}
			else if (step_id.startsWith('profitable'))
			{
				var steps = api.deep_clone(this.steps_items)

				close_steps(steps)

				this.steps_items = steps

				if (this.$refs.capitalization && this.$refs.capitalization.data) {
					api.storage.set(this, `cost_evaluation_${this.group_id}`, JSON.stringify({
						active_step : step_id,
						profitable : {
							cost_evaluation : { capitalization : this.$refs.capitalization.data }
						}
					}))
				}
				else
				{
					api.storage.set(this, `cost_evaluation_${this.group_id}`, JSON.stringify({
						active_step : step_id,
						profitable : {
							cost_evaluation : this.group.cost_evaluation_profitable
						}
					}))
				}
			}
			else
			{
				api.storage.set(this, `cost_evaluation_${this.group_id}`, JSON.stringify({
					active_step : step_id
				}))
			}

			const type = step_id.split('_')[0]
			if (this.$route.params.type != type)
			{
				this.$router.replace({ name : "cost_evaluation" , params : { id : this.$route.params.id, type : type } })
					.catch((e) => {if (e.type != 2) console.error(e)})
			}

			this.active_step = step_id
		},

		evaluate_model()
		{
			if(this.group.cost_evaluation_comparative.modeling && this.group.cost_evaluation_comparative.modeling.fixed || this.group.not_editable || ! this.check_roles([ "model" ]))
				return

			this.progress = true

			return api.call(this, this.service, "evaluate_model", { id : this.group.cost_evaluation_comparative.id },
					response =>
					{
						this.group.cost_evaluation_comparative.modeling.attrs = response.attrs
						this.group.cost_evaluation_comparative.modeling.attrs_indexes = response.attrs_indexes
						this.group.cost_evaluation_comparative.modeling.formula = response.formula
						this.group.cost_evaluation_comparative.modeling.printable_formula = response.printable_formula
						this.group.cost_evaluation_comparative.modeling.printable_formula_html = response.printable_formula_html
						this.group.cost_evaluation_comparative.modeling.depend_status = response.depend_status
						this.group.cost_evaluation_comparative.modeling.params = response.params
						this.group.cost_evaluation_comparative.modeling.stats = response.stats
						this.group.cost_evaluation_comparative.modeling.coefs = response.coefs
						this.group.cost_evaluation_comparative.modeling.objects = response.objects

						o.objects().update_objects(response.objects)

						this.update_steps()
					})
					.then(() => { this.progress = false })
		},
	}
}

</script>
